export default function Logo() {
  return (
      <img src="/logo.svg" alt="Logo" className="pr-3" />
  )
};
